'use client'

import { cookie } from '@utils/utils'
import React, { useEffect, useState } from 'react'
import { APP_COOKIE, APP_SOURCES } from './constants/texts'

const HideOnApp = WrappedComponent =>
  function HideOnAppComponent(props) {
    const [shouldShow, setShouldShow] = useState(true)

    useEffect(() => {
      const cookieValue = cookie(APP_COOKIE)
      const isOnApp = cookieValue && (cookieValue === APP_SOURCES.ANDROID || cookieValue === APP_SOURCES.IOS)
      setShouldShow(!isOnApp)
    }, [])

    return shouldShow ? <WrappedComponent {...props} /> : null
  }

export default HideOnApp
